jQuery( document ).ready( function ( $ ) {
    function ds_setup_collapsible_submenus () {
        var $menu = $( '.enterprise_mobile_menu' ),
            top_level_link = '.enterprise_mobile_menu .menu-item-has-children > a';

        $menu.find( 'a' ).each( function () {
            $( this ).off( 'click' );
            if ( $( this ).is( top_level_link ) ) {
                $( this ).attr( 'href', '#' );
            }
            if ( !$( this ).siblings( '.sub-menu' ).length ) {
                $( this ).on( 'click', function ( event ) {
                    $( this ).parents( '.mobile_nav' ).trigger( 'click' );
                } );
            }
            else {
                $( this ).on( 'click', function ( event ) {
                    event.preventDefault();
                    $( this ).parent().toggleClass( 'visible' );
                } );
            }
        } );
    }
    setTimeout( function () {
        ds_setup_collapsible_submenus();
    }, 700 );

    function checkForPageBlue () {
        const menu = document.getElementById( 'navcheck' );
        const width = window.innerWidth;
        const breakpoint = 1028;

        if ( menu && menu.checked && width >= breakpoint ) {
            menu.checked = false;
        }
    }

    const resizeObserver = new ResizeObserver( () => checkForPageBlue() )
    resizeObserver.observe( document.body )
} );


